import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import ProgressBar from '../../components/ProgressBar/progressbar';
import { Listbox } from '@headlessui/react';
import { ChevronDownIcon, XCircleIcon } from '@heroicons/react/24/solid';
import Styles from './patchcenterStyle.module.scss';

import { useNavigate } from 'react-router-dom';
import SoftwareTable from './softwareTable';
import PredictiveTable from './predictiveTable';
import Circle from './../../components/circleComponent/circle';

const PredictiveAnalysis = () => {
  const navigate = useNavigate();

  const handleCancelBtn = () => {
    navigate('/patchCenter'); // Navigate to the Action page
  };

  let circle0 = {
    data: '300',
    borderColor: '#828282',
    countColor: '#c72727',
    label: 'Total Devices',
  };
  let circle1 = {
    data: '70%',
    borderColor: 'linear-gradient(90deg, #1B9B39 0%, #093513 100%)',
    countColor: '#c72727',
    label: 'Success Percentage',
  };
  let circle2 = {
    data: '30%',
    borderColor: 'linear-gradient(90deg, #D12929 0%, #8A1212 50%, #4A0404 100%)',
    countColor: '#c72727',
    label: 'Failure Percentage',
  };

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title="Preview & Approve" dropdown={2} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-0`} style={{ marginLeft: '60px' }}>
            <ProgressBar stepNum={4} identity={'Device select'} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '50px',
              padding: '20px',
              backgroundColor: '#121212', // dark background
              borderRadius: '12px',
              //marginLeft:'30px'
            }}
          >
            <Circle circleData={circle0} />
            <Circle circleData={circle1} />
            <Circle circleData={circle2} />
          </div>

          <div>
            <PredictiveTable />
          </div>
          <div className="mt-6 flex justify-end space-x-2.5">
            <button className="w-32 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700" onClick={handleCancelBtn}>
              Cancel
            </button>
            <button className="w-32 px-6 py-2 bg-red-600 rounded-[30px] shadow-md hover:bg-red-700">Next</button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PredictiveAnalysis;
